import { Component, Input, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { IFieldConfig } from '../../../../models';
import { AppFormComponent } from '../form';

@Component({
  selector: 'lib-form-field-error, [libFormFieldError]',
  templateUrl: 'form-field-error.component.html',
})
export class FormFieldErrorComponent {
  formComponent = inject(AppFormComponent);

  @Input() public fieldConfig!: IFieldConfig;

  errorMessage(): string {
    const control: AbstractControl = this.formComponent.controls[this.fieldConfig.name];
    if (control) {
      for (const errorCode in control.errors) {
        if (control.errors.hasOwnProperty(errorCode) && (control.touched || this.formComponent.submitted)) {
          return this.getErrorText(errorCode, this.fieldConfig.errorLabel ?? this.fieldConfig.label ?? 'Field', control.errors[errorCode]);
        }
      }
    }
    return '';
  }

  get errorKey() {
    return `${this.fieldConfig.name}err`;
  }

  private getErrorText(code: string, errorLabel: string, value: any): string {
    const config: Record<string, string> = {
      required: `${errorLabel ?? 'Field'} is required`,
      minlength: `${errorLabel ?? 'Field'} must have a minimum of ${value.requiredLength} characters`,
      maxlength: `${errorLabel ?? 'Field'} must have a maximum of ${value.requiredLength} characters`,
      min: `${errorLabel ?? 'Field'} must be a minimum of ${value.min}`,
      max: `${errorLabel ?? 'Field'} must be a maximum of ${value.max}`,
      email: errorLabel ? `${errorLabel} is invalid` : 'Invalid email address entered',
      telephone: errorLabel ? `${errorLabel} is invalid` : 'Invalid telephone entered',
      date: `${errorLabel ?? 'Field'} is invalid`,
      invalidDomain: `${errorLabel || 'Field'} has an invalid domain`,
      money: 'Invalid amount entered',
      invalidPostcode: 'Postcode is invalid',
      number: `Invalid number entered for the ${errorLabel || 'field'}`,
      numberNotZero: `${errorLabel ?? 'Field'} must be greater than 0`,
      multipleCheckboxRequireAtLeastOne: 'At least one option required',
      multipleCheckboxRequireMoreThanOne: 'More than one options required',
      containsNumbers: `${errorLabel ?? 'Field'} cannot contain numbers`,
      integer: `${errorLabel ?? 'Field'} must be a whole number`,
      positive: `${errorLabel ?? 'Field'} cannot be negative`,
    };
    const customMessage =
      this.fieldConfig.errorMessages && this.fieldConfig.errorMessages[code as keyof typeof this.fieldConfig.errorMessages];
    return typeof customMessage === 'string' ? customMessage : config[code];
  }
}
